import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=54b0ac22&"
import script from "./CreateClient.vue?vue&type=script&lang=ts&"
export * from "./CreateClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports